import React from "react";
import useFetch from "@/lib/useFetch";
import { GlassCard, PageTitle, EmptyState } from "@/components/lux";
import { ScrollText } from "lucide-react";

export default function AdminAudit() {
  const { data, loading } = useFetch("/admin/audit-logs");
  return (
    <div className="space-y-6">
      <PageTitle title="Audit Logs" subtitle="Every sensitive action is recorded" />
      <GlassCard className="p-6">
        {loading ? <div className="skeleton h-40" /> : data?.logs?.length ? (
          <div className="max-h-[36rem] overflow-auto">
            <table className="w-full text-sm">
              <thead className="sticky top-0 bg-[var(--bg-2)] text-left text-[var(--text-dim)]"><tr className="border-b border-white/10">
                <th className="py-3">Action</th><th className="py-3">Actor</th><th className="py-3">Target</th><th className="py-3">Meta</th><th className="py-3">Time</th></tr></thead>
              <tbody>
                {data.logs.map((l, i) => (
                  <tr key={i} className="row-hover border-b border-white/5">
                    <td className="py-3 capitalize text-white">{l.action?.replace(/_/g, " ")}</td>
                    <td className="py-3 text-[var(--text-dim)]">{(l.actor_id || "").slice(-6)}</td>
                    <td className="py-3 text-[var(--text-dim)]">{l.target_id || "—"}</td>
                    <td className="py-3 max-w-[240px] truncate text-[var(--text-dim)]">{JSON.stringify(l.meta)}</td>
                    <td className="py-3 text-[var(--text-dim)]">{(l.created_at || "").slice(0, 16).replace("T", " ")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : <EmptyState icon={ScrollText} title="No audit logs yet" />}
      </GlassCard>
    </div>
  );
}
